import { render, staticRenderFns } from "./TemplateGroups.vue?vue&type=template&id=2e8fa3c4&scoped=true&"
import script from "./TemplateGroups.vue?vue&type=script&lang=js&"
export * from "./TemplateGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fa3c4",
  null
  
)

export default component.exports